import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CreditPackFilter from '../components/filters/credit-pack-filter';
import CreditPacksTable from '../components/tables/credit-packs-table';

const CreditPacksListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()


  return (<>
    <PageHeader
      title="پکیج ها"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/credit-packs-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <CreditPackFilter onFinish={setFitlers} />
    <CreditPacksTable filters={filters} />
  </>);
}

export default CreditPacksListRoute;
